import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-dark rounded-lg border border-gray-700 p-4 space-y-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center space-x-3" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["aria-checked"]
const _hoisted_7 = { class: "ml-3 text-sm font-medium text-gray-300" }
const _hoisted_8 = { class: "flex items-center space-x-1" }
const _hoisted_9 = { class: "text-sm text-gray-400" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_13 = { class: "border-t border-gray-700 pt-4" }
const _hoisted_14 = { class: "flex items-center justify-between mb-4" }
const _hoisted_15 = { class: "flex items-center space-x-2" }
const _hoisted_16 = { class: "flex rounded-lg border border-gray-700 p-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "space-y-2" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "text-center py-4 text-gray-400 text-sm border border-dashed border-gray-700 rounded-lg"
}
const _hoisted_26 = { class: "bg-dark-secondary rounded-lg" }
const _hoisted_27 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-6" }
const _hoisted_28 = { class: "lg:col-span-7 lg:sticky lg:top-6 space-y-6" }
const _hoisted_29 = { class: "bg-dark rounded-lg border border-gray-700 overflow-hidden" }
const _hoisted_30 = { class: "flex items-center justify-between p-4 border-b border-gray-700" }
const _hoisted_31 = { class: "flex items-center space-x-1" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "lg:col-span-5 space-y-4" }
const _hoisted_34 = { class: "bg-dark rounded-lg border border-gray-700 p-4" }
const _hoisted_35 = { class: "flex gap-2" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "flex items-center gap-2" }
const _hoisted_38 = { class: "relative w-3 h-3 rounded-sm overflow-hidden" }
const _hoisted_39 = {
  key: 0,
  class: "absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-primary"
}
const _hoisted_40 = { class: "bg-dark rounded-lg border border-gray-700 p-4" }
const _hoisted_41 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_42 = { class: "space-y-4" }
const _hoisted_43 = { class: "relative group" }
const _hoisted_44 = { class: "relative group" }
const _hoisted_45 = { class: "relative group" }
const _hoisted_46 = { class: "space-y-4" }
const _hoisted_47 = { class: "relative group" }
const _hoisted_48 = { class: "relative group" }
const _hoisted_49 = { class: "bg-dark rounded-lg border border-gray-700 p-4" }
const _hoisted_50 = { class: "space-y-4" }
const _hoisted_51 = { class: "bg-dark rounded-lg border border-gray-700 p-4" }
const _hoisted_52 = { class: "flex items-center justify-between mb-4" }
const _hoisted_53 = { class: "space-y-2" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = ["onClick"]

import { ref, onMounted, watch } from 'vue'
import SearchWidgetPreview from '@/components/search/SearchWidgetPreview.vue'
import { useOrgStore } from '@/stores/org'

type RuleField = keyof typeof FIELD_LABELS
type RuleOperator = keyof typeof OPERATOR_LABELS
type LogicalOperator = 'AND' | 'OR'

interface Rule {
  field: RuleField
  operator: RuleOperator
  value: string
}

interface Customization {
  appearance: {
    thread: {
      color: string
      background: string
      font: string
      linkColor: string
    }
    input: {
      color: string
      background: string
      size: string
      highlight: string
      placeholder: {
        text: string
        color: string
      }
    }
    cta: {
      background: string
    }
  }
  promptSuggestions: Array<{ value: string }>
  defaultFont: string
  rules: {
    operator: LogicalOperator
    conditions: Rule[]
  }
}

interface Theme {
  name: string
  appearance: Customization['appearance']
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchCustomizationView',
  setup(__props) {

const presetThemes = [
  {
    name: 'Light',
    appearance: {
      thread: {
        color: '#000000',
        background: '#ffffff',
        font: '',
        linkColor: '#a1a1a1'
      },
      input: {
        color: '#000000',
        background: '#ffffff',
        size: '16px',
        highlight: '#e5e7eb',
        placeholder: {
          text: 'Ask anything...',
          color: '#808080'
        }
      },
      cta: {
        background: '#814ac8'
      }
    }
  },
  {
    name: 'Dark',
    appearance: {
      thread: {
        color: '#ffffff',
        background: '#1f2937',
        font: '',
        linkColor: '#a1a1a1'
      },
      input: {
        color: '#ffffff',
        background: '#111827',
        size: '16px',
        highlight: '#374151',
        placeholder: {
          text: 'Ask anything...',
          color: '#9ca3af'
        }
      },
      cta: {
        background: '#814ac8'
      }
    }
  },
  {
    name: 'Warm',
    appearance: {
      thread: {
        color: '#000000',
        background: '#fbe7d5',
        font: '',
        linkColor: '#a1a1a1'
      },
      input: {
        color: '#000000',
        background: '#ffffff',
        size: '16px',
        highlight: '#f97316',
        placeholder: {
          text: 'Ask anything...',
          color: '#808080'
        }
      },
      cta: {
        background: '#f97316'
      }
    }
  },
  {
    name: 'Minimal',
    appearance: {
      thread: {
        color: '#000000',
        background: '#ffffff',
        font: '',
        linkColor: '#a1a1a1'
      },
      input: {
        color: '#000000',
        background: '#f8fafc',
        size: '16px',
        highlight: '#e2e8f0',
        placeholder: {
          text: 'Ask anything...',
          color: '#808080'
        }
      },
      cta: {
        background: '#64748b'
      }
    }
  }
]

const FIELD_LABELS = {
  page_url: 'Page URL',
  page_title: 'Page Title'
} as const

const OPERATOR_LABELS = {
  equals: 'Equals',
  not_equals: 'Not Equals',
  contains: 'Contains',
  not_contains: 'Not Contains'
} as const

// Default configuration
const defaultConfig: Customization = {
  appearance: {
    thread: {
      color: '#000000',
      background: '#fbe7d5',
      font: '',
      linkColor: '#a1a1a1'
    },
    input: {
      color: '#000000',
      background: '#ffffff',
      size: '16px',
      highlight: '#a1a1a1',
      placeholder: {
        text: 'Ask anything...',
        color: '#808080'
      }
    },
    cta: {
      background: '#814ac8'
    }
  },
  promptSuggestions: [
    { value: 'Best topper for side sleepers?' },
    { value: 'What is the best pillow for side sleepers?' },
    { value: 'Sore neck and hot sleeper' },
    { value: 'What is the best mattress for back pain?' }
  ],
  defaultFont: 'https://storage.googleapis.com/greet-public/fonts/Alliance.woff',
  rules: {
    operator: 'AND' as LogicalOperator,
    conditions: []
  }
}

const orgStore = useOrgStore()
const isSaving = ref(false)
const saveSuccess = ref(false)
const saveError = ref<string | null>(null)

const isWidgetActive = ref(false)
const currentTheme = ref('')
const previewDevice = ref<'desktop' | 'tablet' | 'mobile'>('desktop')
const customization = ref<Customization>(structuredClone(defaultConfig))

// Load initial widget config
onMounted(async () => {
  console.log('Component mounted, initializing...')
  
  // Make sure org data is loaded
  if (!orgStore.orgData) {
    console.log('No org data, fetching...')
    await orgStore.fetchOrgData()
    orgStore.watchOrgData() // Setup live updates
  }
  
  console.log('Current org data:', orgStore.orgData)
  
  if (orgStore.orgData?.widget) {
    console.log('Loading existing widget config:', orgStore.orgData.widget)
    const widget = orgStore.orgData.widget
    
    // Reset to default config first
    customization.value = structuredClone(defaultConfig)
    
    // Update active state
    isWidgetActive.value = widget.is_active
    
    // Update rules
    customization.value.rules.operator = widget.visibility.operator as LogicalOperator
    customization.value.rules.conditions = widget.visibility.rules.map(rule => ({
      field: rule.field as RuleField,
      operator: rule.operator as RuleOperator,
      value: rule.value
    }))
    
    // Update styles if they exist
    if (widget.widget_styles) {
      const styles = widget.widget_styles
      
      if (styles.appearance) {
        customization.value.appearance = styles.appearance
        updateCurrentTheme()
      }
      
      if (styles.promptSuggestions) {
        customization.value.promptSuggestions = styles.promptSuggestions
      }
      
      if (styles.defaultFont) {
        customization.value.defaultFont = styles.defaultFont
      }
    }
  } else {
    console.log('No existing widget config found, using default configuration')
    customization.value = structuredClone(defaultConfig)
  }
})

// Watch for org data changes
watch(() => orgStore.orgData?.widget, (newWidget) => {
  if (newWidget) {
    console.log('Widget config updated:', newWidget)
    
    // Only update if we're not currently saving
    if (!isSaving.value) {
      // Reset to default config first
      customization.value = structuredClone(defaultConfig)
      
      // Update active state
      isWidgetActive.value = newWidget.is_active
      
      // Update rules
      customization.value.rules.operator = newWidget.visibility.operator as LogicalOperator
      customization.value.rules.conditions = newWidget.visibility.rules.map(rule => ({
        field: rule.field as RuleField,
        operator: rule.operator as RuleOperator,
        value: rule.value
      }))
      
      // Update styles if they exist
      if (newWidget.widget_styles) {
        const styles = newWidget.widget_styles
        
        if (styles.appearance) {
          customization.value.appearance = styles.appearance
        }
        
        if (styles.promptSuggestions) {
          customization.value.promptSuggestions = styles.promptSuggestions
        }
        
        if (styles.defaultFont) {
          customization.value.defaultFont = styles.defaultFont
        }
      }
    }
  }
}, { deep: true })

// Watch for any color value changes to update theme selection
watch([
  () => customization.value.appearance.thread.color,
  () => customization.value.appearance.thread.background,
  () => customization.value.appearance.thread.linkColor,
  () => customization.value.appearance.input.color,
  () => customization.value.appearance.input.background,
  () => customization.value.appearance.input.highlight,
  () => customization.value.appearance.input.placeholder.color,
  () => customization.value.appearance.cta.background
], () => {
  if (!isSaving.value) {
    console.log('Color value changed, checking theme match...')
    updateCurrentTheme()
  }
})

const transformToWidgetConfig = () => {
  return {
    is_active: isWidgetActive.value,
    visibility: {
      operator: customization.value.rules.operator,
      rules: customization.value.rules.conditions
    },
    widget_styles: {
      appearance: customization.value.appearance,
      promptSuggestions: customization.value.promptSuggestions,
      defaultFont: customization.value.defaultFont
    }
  }
}

const saveChanges = async () => {
  console.log('Starting save process...')
  isSaving.value = true
  saveSuccess.value = false
  saveError.value = null

  try {
    const widgetConfig = transformToWidgetConfig()
    console.log('Widget config to save:', widgetConfig)
    console.log('Current org ID:', orgStore.orgData?.id)
    
    if (!orgStore.orgData?.id) {
      throw new Error('No org ID found')
    }
    
    await orgStore.updateWidgetConfig(widgetConfig)
    console.log('Save successful')
    saveSuccess.value = true
    setTimeout(() => {
      saveSuccess.value = false
    }, 2000)
  } catch (err: any) {
    saveError.value = err.message
    console.error('Error saving widget config:', err)
    alert('Failed to save: ' + err.message) // Temporary debug alert
  } finally {
    isSaving.value = false
  }
}


const isThemeMatching = (theme: Theme): boolean => {
  const current = customization.value.appearance
  const themeAppearance = theme.appearance
  
  // Helper function to compare values with type safety
  const compareValues = (a: string, b: string): boolean => {
    // Convert to lowercase for case-insensitive comparison of hex colors
    return a.toLowerCase() === b.toLowerCase()
  }
  
  // Check all color values match exactly
  return (
    compareValues(current.thread.color, themeAppearance.thread.color) &&
    compareValues(current.thread.background, themeAppearance.thread.background) &&
    compareValues(current.thread.linkColor, themeAppearance.thread.linkColor) &&
    compareValues(current.input.color, themeAppearance.input.color) &&
    compareValues(current.input.background, themeAppearance.input.background) &&
    compareValues(current.input.highlight, themeAppearance.input.highlight) &&
    compareValues(current.input.placeholder.color, themeAppearance.input.placeholder.color) &&
    compareValues(current.cta.background, themeAppearance.cta.background)
  )
}

const updateCurrentTheme = () => {
  const matchingTheme = presetThemes.find(theme => isThemeMatching(theme))
  currentTheme.value = matchingTheme?.name || ''
}

const applyTheme = (theme: Theme) => {
  // Create a deep copy of the theme appearance to avoid reference issues
  const newAppearance = JSON.parse(JSON.stringify(theme.appearance))
  
  // Update the appearance values
  customization.value = {
    ...customization.value,
    appearance: newAppearance
  }
  
  // Theme name will be updated by the watcher when colors are verified to match
  console.log('Applied theme:', theme.name)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[38] || (_cache[38] = _createElementVNode("div", null, [
      _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-100" }, "Widget Customization"),
      _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Customize your search experience")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isWidgetActive.value = !isWidgetActive.value)),
              class: _normalizeClass(["relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-dark", isWidgetActive.value ? 'bg-primary' : 'bg-gray-700']),
              role: "switch",
              "aria-checked": isWidgetActive.value
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", isWidgetActive.value ? 'translate-x-5' : 'translate-x-0'])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", isWidgetActive.value ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in'])
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("svg", {
                    class: "h-3 w-3 text-gray-400",
                    fill: "none",
                    viewBox: "0 0 12 12"
                  }, [
                    _createElementVNode("path", {
                      d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ]), 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", isWidgetActive.value ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out'])
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("svg", {
                    class: "h-3 w-3 text-primary",
                    fill: "currentColor",
                    viewBox: "0 0 12 12"
                  }, [
                    _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                  ], -1)
                ]), 2)
              ], 2)
            ], 10, _hoisted_6),
            _createElementVNode("span", _hoisted_7, " Widget is " + _toDisplayString(isWidgetActive.value ? 'active' : 'inactive'), 1)
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "h-4 w-px bg-gray-700" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["w-2 h-2 rounded-full", isWidgetActive.value ? 'bg-green-500' : 'bg-gray-500'])
            }, null, 2),
            _createElementVNode("span", _hoisted_9, "Status: " + _toDisplayString(isWidgetActive.value ? 'Live' : 'Disabled'), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: saveChanges,
          disabled: isSaving.value,
          class: _normalizeClass(["inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark disabled:opacity-50 disabled:cursor-not-allowed", [
              saveSuccess.value
                ? 'bg-emerald-500/10 text-emerald-500 ring-emerald-500 hover:bg-emerald-500/20'
                : 'bg-primary text-white ring-primary hover:bg-primary-dark'
            ]])
        }, [
          (isSaving.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[13] || (_cache[13] = [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }, null, -1),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }, null, -1)
              ])))
            : (saveSuccess.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[14] || (_cache[14] = [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                    "clip-rule": "evenodd"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(isSaving.value ? 'Saving...' : saveSuccess.value ? 'Saved!' : 'Save Changes'), 1)
        ], 10, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-200" }, "Visibility Rules", -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-sm text-gray-400" }, "Combine rules with:", -1)),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['AND', 'OR'] as LogicalOperator[], (op) => {
                return _createElementVNode("button", {
                  key: op,
                  onClick: ($event: any) => (customization.value.rules.operator = op),
                  class: _normalizeClass([
                    'px-3 py-1 text-sm font-medium rounded transition-colors',
                    customization.value.rules.operator === op
                      ? 'bg-primary text-white'
                      : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
                  ])
                }, _toDisplayString(op), 11, _hoisted_17)
              }), 64))
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (customization.value.rules.conditions.push({ field: 'page_url' as RuleField, operator: 'equals' as RuleOperator, value: '' }))),
              class: "ml-4 px-3 py-1 text-sm font-medium text-gray-200 rounded-lg border border-gray-700 hover:border-primary/30 hover:bg-primary/10 hover:text-primary"
            }, " Add Rule ")
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customization.value.rules.conditions, (rule, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex items-center gap-2"
            }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((rule.field) = $event),
                class: "bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FIELD_LABELS, (label, field) => {
                  return _createElementVNode("option", {
                    key: field,
                    value: field
                  }, _toDisplayString(label), 9, _hoisted_20)
                }), 64))
              ], 8, _hoisted_19), [
                [_vModelSelect, rule.field]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((rule.operator) = $event),
                class: "bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(OPERATOR_LABELS, (label, op) => {
                  return _createElementVNode("option", {
                    key: op,
                    value: op
                  }, _toDisplayString(label), 9, _hoisted_22)
                }), 64))
              ], 8, _hoisted_21), [
                [_vModelSelect, rule.operator]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((rule.value) = $event),
                type: "text",
                class: "flex-1 bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                placeholder: 'Enter ' + FIELD_LABELS[rule.field].toLowerCase()
              }, null, 8, _hoisted_23), [
                [_vModelText, rule.value]
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (customization.value.rules.conditions.splice(index, 1)),
                class: "p-2 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-500/10",
                title: "Remove rule"
              }, _cache[17] || (_cache[17] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-5 w-5",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" })
                ], -1)
              ]), 8, _hoisted_24)
            ]))
          }), 128)),
          (customization.value.rules.conditions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No rules added yet. Click \"Add Rule\" to start defining visibility conditions. "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-100" }, "Live Preview", -1)),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList((['desktop', 'tablet', 'mobile'] as const), (device) => {
                  return _createElementVNode("button", {
                    key: device,
                    onClick: ($event: any) => (previewDevice.value = device),
                    class: _normalizeClass(["p-2 rounded-md text-sm font-medium transition-colors", [
                    previewDevice.value === device
                      ? 'bg-gray-700 text-gray-100'
                      : 'text-gray-400 hover:text-gray-300'
                  ]])
                  }, _toDisplayString(device), 11, _hoisted_32)
                }), 64))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["relative w-full aspect-[4/3]", {
              'max-w-sm mx-auto': previewDevice.value === 'mobile',
              'max-w-2xl mx-auto': previewDevice.value === 'tablet'
            }])
            }, [
              _createVNode(SearchWidgetPreview, {
                customization: customization.value,
                device: previewDevice.value
              }, null, 8, ["customization", "device"])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center justify-between mb-3" }, [
              _createElementVNode("h2", { class: "text-sm font-medium text-gray-100" }, "Quick Themes"),
              _createElementVNode("div", { class: "h-px flex-1 bg-gray-700/50 mx-3" })
            ], -1)),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presetThemes, (theme) => {
                return _createElementVNode("button", {
                  key: theme.name,
                  onClick: ($event: any) => (applyTheme(theme)),
                  class: _normalizeClass(["group flex-1 relative px-3 py-2 rounded-md border transition-all overflow-hidden", [
                  currentTheme.value
                    ? currentTheme.value === theme.name
                      ? 'border-primary/50 bg-primary/5 hover:bg-primary/10'
                      : 'border-gray-800 hover:border-gray-700 hover:bg-gray-800/30'
                    : 'border-gray-800 hover:border-gray-700 hover:bg-gray-800/30'
                ]])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", {
                        class: "absolute inset-0",
                        style: _normalizeStyle({ backgroundColor: theme.appearance.input.background })
                      }, null, 4),
                      _createElementVNode("div", {
                        class: "absolute bottom-0 right-0 w-1.5 h-1.5 rounded-tl",
                        style: _normalizeStyle({ backgroundColor: theme.appearance.cta.background })
                      }, null, 4)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-xs font-medium", [
                    currentTheme.value === theme.name
                      ? 'text-primary'
                      : 'text-gray-400 group-hover:text-gray-300'
                  ]])
                    }, _toDisplayString(theme.name), 3)
                  ]),
                  (currentTheme.value === theme.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_36)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-100 mb-4" }, "Colors", -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Input Text", -1)),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", {
                      class: "absolute inset-0 rounded-lg",
                      style: _normalizeStyle({ backgroundColor: customization.value.appearance.input.color })
                    }, null, 4),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customization.value.appearance.input.color) = $event)),
                      type: "color",
                      class: "opacity-0 w-full h-12 cursor-pointer relative z-10"
                    }, null, 512), [
                      [_vModelText, customization.value.appearance.input.color]
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg border border-gray-700 pointer-events-none group-hover:border-gray-600 transition-colors" }, null, -1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Input Background", -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", {
                      class: "absolute inset-0 rounded-lg",
                      style: _normalizeStyle({ backgroundColor: customization.value.appearance.input.background })
                    }, null, 4),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customization.value.appearance.input.background) = $event)),
                      type: "color",
                      class: "opacity-0 w-full h-12 cursor-pointer relative z-10"
                    }, null, 512), [
                      [_vModelText, customization.value.appearance.input.background]
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg border border-gray-700 pointer-events-none group-hover:border-gray-600 transition-colors" }, null, -1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Placeholder", -1)),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", {
                      class: "absolute inset-0 rounded-lg",
                      style: _normalizeStyle({ backgroundColor: customization.value.appearance.input.placeholder.color })
                    }, null, 4),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customization.value.appearance.input.placeholder.color) = $event)),
                      type: "color",
                      class: "opacity-0 w-full h-12 cursor-pointer relative z-10"
                    }, null, 512), [
                      [_vModelText, customization.value.appearance.input.placeholder.color]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg border border-gray-700 pointer-events-none group-hover:border-gray-600 transition-colors" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", null, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Highlight", -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      class: "absolute inset-0 rounded-lg",
                      style: _normalizeStyle({ backgroundColor: customization.value.appearance.input.highlight })
                    }, null, 4),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customization.value.appearance.input.highlight) = $event)),
                      type: "color",
                      class: "opacity-0 w-full h-12 cursor-pointer relative z-10"
                    }, null, 512), [
                      [_vModelText, customization.value.appearance.input.highlight]
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg border border-gray-700 pointer-events-none group-hover:border-gray-600 transition-colors" }, null, -1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Button", -1)),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", {
                      class: "absolute inset-0 rounded-lg",
                      style: _normalizeStyle({ backgroundColor: customization.value.appearance.cta.background })
                    }, null, 4),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customization.value.appearance.cta.background) = $event)),
                      type: "color",
                      class: "opacity-0 w-full h-12 cursor-pointer relative z-10"
                    }, null, 512), [
                      [_vModelText, customization.value.appearance.cta.background]
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg border border-gray-700 pointer-events-none group-hover:border-gray-600 transition-colors" }, null, -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-100 mb-4" }, "Text", -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", null, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Font Size", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customization.value.appearance.input.size) = $event)),
                  class: "w-full bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                }, _cache[31] || (_cache[31] = [
                  _createElementVNode("option", { value: "14px" }, "Small", -1),
                  _createElementVNode("option", { value: "16px" }, "Medium", -1),
                  _createElementVNode("option", { value: "18px" }, "Large", -1)
                ]), 512), [
                  [_vModelSelect, customization.value.appearance.input.size]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Placeholder Text", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customization.value.appearance.input.placeholder.text) = $event)),
                  type: "text",
                  class: "w-full bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                  placeholder: "Enter placeholder text..."
                }, null, 512), [
                  [_vModelText, customization.value.appearance.input.placeholder.text]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-100" }, "Prompt Suggestions", -1)),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (customization.value.promptSuggestions.push({ value: '' }))),
                class: "p-2 text-gray-400 hover:text-gray-300 rounded-md hover:bg-gray-800"
              }, _cache[35] || (_cache[35] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-5 w-5",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                    "clip-rule": "evenodd"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customization.value.promptSuggestions, (suggestion, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "group flex items-center space-x-2"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((suggestion.value) = $event),
                    type: "text",
                    class: "flex-1 bg-dark border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "Enter suggestion..."
                  }, null, 8, _hoisted_54), [
                    [_vModelText, suggestion.value]
                  ]),
                  (customization.value.promptSuggestions.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (customization.value.promptSuggestions.splice(index, 1)),
                        class: "p-2 text-gray-600 hover:text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                      }, _cache[37] || (_cache[37] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-5 w-5",
                          viewBox: "0 0 20 20",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)
                      ]), 8, _hoisted_55))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})